/**
 * @description header component
 */

import {h, Component} from 'preact';
import './header.scss';

export default (props)=>{
  return (
    <header class='app__header'/>
  );
}


/** WEBPACK FOOTER **
 ** ./components/header/header.jsx
 **/